<div class="min-h-screen flex items-center justify-center bg-black bg-opacity-80">
  <div class="w-full max-w-md px-4">
    <!-- Card -->
    <div class="bg-[#151515] text-white rounded-2xl shadow-xl px-8 py-10 border border-gray-800">
      <!-- Logo -->
      <div class="flex justify-center mb-6">
        <img src="assets/img/logo_redal.svg" alt="REDAL" class="h-12" />
      </div>

      <!-- Título -->
      <h1 class="text-center text-2xl font-semibold tracking-wide mb-6">
        RECUPERAR SENHA
      </h1>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <!-- Email -->
        <div class="mb-4">
          <input type="email" formControlName="email" placeholder="Email" class="w-full rounded-md bg-[#1f1f1f] border border-gray-600 px-3 py-2 text-sm text-white
                   placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500" />
          <p *ngIf="hasError('email', 'required')" class="mt-1 text-xs text-red-400">
            Informe o email.
          </p>
          <p *ngIf="hasError('email', 'email')" class="mt-1 text-xs text-red-400">
            Informe um email válido.
          </p>
        </div>

        <!-- Botão principal -->
        <button type="submit" [disabled]="forgotPasswordForm.invalid"
                [style.opacity]="forgotPasswordForm.invalid ? '0.6' : '1'" class="w-full mt-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm py-2.5 rounded-md
                 transition-colors disabled:cursor-not-allowed">
          Enviar link de recuperação
        </button>

        <!-- Divider -->
        <div class="flex items-center mt-6 mb-4">
          <div class="flex-1 h-px bg-gray-700"></div>
          <span class="px-3 text-xs text-gray-400">ou</span>
          <div class="flex-1 h-px bg-gray-700"></div>
        </div>

        <!-- Link para login -->
        <p class="text-center text-xs text-gray-300">
          Lembrou sua senha?
          <a routerLink="/auth/login" class="text-red-400 font-semibold hover:underline">
            Voltar para entrar
          </a>
        </p>
      </form>
    </div>

    <!-- Rodapé -->
    <p class="mt-4 text-center text-[11px] text-gray-400">
      © 2025 REDAL – Todos os direitos reservados.
    </p>
  </div>
</div>